import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "cart mt-3" };
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = ["onClick"];
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = { class: "row" };
const _hoisted_6 = { class: "col-6 col-md-3" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("div", { class: "col-md-6 d-none d-md-block" }, null, -1);
const _hoisted_8 = { class: "col-6 col-md-3" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_icon = _resolveComponent("g-icon");
    const _component_g_ozg_payment__lines = _resolveComponent("g-ozg-payment__lines");
    const _component_g_ozg_payment__invoice = _resolveComponent("g-ozg-payment__invoice");
    const _component_g_ozg_payment__email = _resolveComponent("g-ozg-payment__email");
    const _component_g_ozg_payment__payment = _resolveComponent("g-ozg-payment__payment");
    const _component_g_ozg_payment__terms = _resolveComponent("g-ozg-payment__terms");
    const _component_g_button = _resolveComponent("g-button");
    const _component_g_form = _resolveComponent("g-form");
    return (_ctx.cartData)
        ? (_openBlock(), _createBlock(_component_g_form, {
            key: 0,
            ref: "frmMain",
            "data-object": _ctx.cartData
        }, {
            default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                    (_ctx.cartMessages)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.cartMessages, (message) => {
                            return (_openBlock(), _createElementBlock("div", {
                                class: _normalizeClass(["alert d-flex align-items-center pt-2 pb-2", [message.style ? 'alert-' + message.style : 'alert-warning', !message.persistent ? 'alert-dismissible' : '']]),
                                role: "alert"
                            }, [
                                (message.iconUrl)
                                    ? (_openBlock(), _createBlock(_component_g_icon, {
                                        key: 0,
                                        class: "flex-shrink-0 me-2",
                                        width: "24",
                                        height: "24",
                                        src: message.iconUrl,
                                        "aria-label": "Warning:"
                                    }, null, 8, ["src"]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", {
                                    innerHTML: message.description
                                }, null, 8, _hoisted_2),
                                (!message.persistent)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        type: "button",
                                        class: "btn-close p-0",
                                        style: { "padding-top": "1.5rem !important", "padding-right": "1.5rem !important" },
                                        "aria-label": "Close",
                                        onClick: ($event) => (_ctx.cmdRemoveMessage(message))
                                    }, null, 8, _hoisted_3))
                                    : _createCommentVNode("", true)
                            ], 2));
                        }), 256))
                        : _createCommentVNode("", true),
                    (_ctx.cartSchema?.messages)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.cartSchema?.messages, (message) => {
                            return (_openBlock(), _createElementBlock("div", {
                                class: _normalizeClass(["alert d-flex align-items-center pt-2 pb-2", [message.style ? 'alert-' + message.style : 'alert-warning']]),
                                role: "alert"
                            }, [
                                (message.iconUrl)
                                    ? (_openBlock(), _createBlock(_component_g_icon, {
                                        key: 0,
                                        class: "flex-shrink-0 me-2",
                                        width: "24",
                                        height: "24",
                                        src: message.iconUrl,
                                        "aria-label": "Warning:"
                                    }, null, 8, ["src"]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", {
                                    innerHTML: message.description
                                }, null, 8, _hoisted_4)
                            ], 2));
                        }), 256))
                        : _createCommentVNode("", true),
                    _createVNode(_component_g_ozg_payment__lines, {
                        cart: _ctx.cart,
                        schema: _ctx.cartSchema,
                        data: _ctx.cartData
                    }, null, 8, ["cart", "schema", "data"]),
                    (_ctx.cartSchema?.invoicing)
                        ? (_openBlock(), _createBlock(_component_g_ozg_payment__invoice, {
                            key: 2,
                            cart: _ctx.cart,
                            schema: _ctx.cartSchema,
                            data: _ctx.cartData
                        }, null, 8, ["cart", "schema", "data"]))
                        : _createCommentVNode("", true),
                    _createVNode(_component_g_ozg_payment__email, {
                        cart: _ctx.cart,
                        schema: _ctx.cartSchema,
                        data: _ctx.cartData
                    }, null, 8, ["cart", "schema", "data"]),
                    _createVNode(_component_g_ozg_payment__payment, {
                        cart: _ctx.cart,
                        schema: _ctx.cartSchema,
                        data: _ctx.cartData
                    }, null, 8, ["cart", "schema", "data"]),
                    _createVNode(_component_g_ozg_payment__terms, {
                        cart: _ctx.cart,
                        schema: _ctx.cartSchema,
                        data: _ctx.cartData
                    }, null, 8, ["cart", "schema", "data"])
                ]),
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                        (!_ctx.page.isFirstPage)
                            ? (_openBlock(), _createBlock(_component_g_button, {
                                key: 0,
                                text: "<< Zurück",
                                "button-style": "btn-outline-secondary",
                                disabled: !_ctx.page.previousPage,
                                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.onCommand('back', { page: _ctx.page })))
                            }, null, 8, ["disabled"]))
                            : _createCommentVNode("", true)
                    ]),
                    _hoisted_7,
                    _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_g_button, {
                            text: "Jetzt bezahlen",
                            "is-loading": _ctx.isWorking,
                            onClick: _ctx.commit
                        }, null, 8, ["is-loading", "onClick"])
                    ])
                ])
            ]),
            _: 1
        }, 8, ["data-object"]))
        : _createCommentVNode("", true);
}
